import {
  inject, provide, reactive, getCurrentInstance,
} from 'vue';

import { getTheme, setTheme, ThemeOpts } from './theme';

import BrowserStorage from '@/util/localStorage/BrowserStorage';

const PROVIDE_UNIQUE_NAME = 'USE_ANTD_THEME';

export type typeTableDensity = 'large' | 'middle' | 'small';
interface ConfigProperties {
  name: ThemeOpts;
  collapsed: boolean;
  tableDensity: typeTableDensity,
}

const collpased = new BrowserStorage('menu-collpased', false, 'config-');
const tableDensity = new BrowserStorage<typeTableDensity>('table-density', 'large', 'config-');

export const useConfigProvider = (): void => {
  const theme = getTheme();
  setTheme(theme);
  provide(PROVIDE_UNIQUE_NAME, reactive<ConfigProperties>({
    name: theme,
    collapsed: collpased.get(),
    tableDensity: tableDensity.get(),
  }));
};

const useConfig = () => {
  const vm = getCurrentInstance()?.proxy;

  if (!vm) {
    throw new Error(
      'vue-query hooks can only be used inside setup() function.',
    );
  }
  const config = inject<ConfigProperties>(PROVIDE_UNIQUE_NAME);
  if (!config) {
    throw new Error(
      "No apiClient found in Vue context, use 'useConfigProvider' to set one in the root component.",
    );
  }

  const toogleTheme = () => {
    config.name = config.name === ThemeOpts.dark ? ThemeOpts.light : ThemeOpts.dark;
    setTheme(config.name);
  };

  const toogleCollapse = () => {
    config.collapsed = !config.collapsed;
    collpased.set(config.collapsed);
  };

  const setDensity = (density: typeTableDensity) => {
    config.tableDensity = density;
    tableDensity.set(density);
  };

  return {
    config,
    toogleTheme,
    toogleCollapse,
    setDensity,
  };
};

export default useConfig;
